import { render } from "./DashboardCard.vue?vue&type=template&id=4af1429e&scoped=true"
import script from "./DashboardCard.vue?vue&type=script&lang=js"
export * from "./DashboardCard.vue?vue&type=script&lang=js"

import "./DashboardCard.vue?vue&type=style&index=0&id=4af1429e&lang=postcss&scoped=true"

import exportComponent from "/Users/dharmik/www/pfizer-invoicing-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4af1429e"]])

export default __exports__